const CYRILLIC_TO_LATIN: Record<string, string> = {
  а:"a", б:"b", в:"v", г:"g", д:"d", е:"e", ё:"e", ж:"zh", з:"z", и:"i", й:"y",
  к:"k", л:"l", м:"m", н:"n", о:"o", п:"p", р:"r", с:"s", т:"t", у:"u", ф:"f",
  х:"h", ц:"ts", ч:"ch", ш:"sh", щ:"sch", ъ:"", ы:"y", ь:"", э:"e", ю:"yu", я:"ya",
};

export const slugify = (value: string) => value
  .toLowerCase()
  .trim()
  .replace(/[а-яё]/g, (letter) => CYRILLIC_TO_LATIN[letter] ?? letter)
  .replace(/[^a-z0-9]+/g, "-")
  .replace(/^-|-$/g, "")
  .slice(0, 63);

const RESERVED_SUBDOMAINS = new Set([
  "admin", "api", "app", "assets", "autoconfig", "cpanel", "ftp", "imap", "mail",
  "pop", "smtp", "static", "status", "support", "webmail", "www",
]);

export const normalizeSubdomain = (value: string) => value
  .toLowerCase()
  .replace(/[^a-z0-9-]/g, "")
  .slice(0, 63);

export const validateSubdomain = (value: string): string | null => {
  if (value.length < 3 || value.length > 63) return "От 3 до 63 символов";
  if (!/^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(value)) return "Дефис нельзя ставить в начале или конце";
  if (value.includes("--")) return "Два дефиса подряд не допускаются";
  if (RESERVED_SUBDOMAINS.has(value)) return "Этот поддомен зарезервирован";
  return null;
};
